// eslint-disable-next-line import/prefer-default-export
export const ManagerBidAction = Object.freeze({
    Publish: 0,
    Cancel: 1,
    RolloutStatusDetails: 2,
    ForceStart: 3,
    ForceClose: 4,
});
